import React from 'react';
import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionServerSelectors, SessionSiteSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { isSelfServiceSchedulingEnabledForAllContentTypes } from '~src/schedule/utils/ScheduleUtils';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { NavPanel, NavPanelOwnProps, NavPanelStateProps } from './NavPanel';

const mapStateToProps: MapStateToProps<NavPanelStateProps> = (state: AppState) => ({
  siteUrls: siteUrlsSelector(state),
  spaceType: state.spaceInfo.spaceType,
  currentNavLocation: NavLocationSelectors.selectNavLocation(state),
  inServerArea: NavLocationSelectors.inServerArea(state),
  isSessionSiteAdmin: SessionSiteSelectors.isSessionSiteAdmin(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  isSessionMultiSite: SessionUserSelectors.isSessionMultiSite(state),
  isSiteAdminSettingsEnabled: SessionServerSelectors.isSiteAdminSettingsEnabled(state),
  isAdminViewsEnabled: SessionServerSelectors.isAdminViewsEnabled(state),
  isCatalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  isNamedSharingEnabled: SessionSiteSelectors.isNamedSharingEnabled(state),
  isVizRecommendationsEnabled: SessionSiteSelectors.isVizRecommendationsEnabled(state),
  shouldShowPersonalSpace: SessionSiteSelectors.shouldShowPersonalSpace(state),
  isSitePickerEnabled: SessionServerSelectors.sitePickerEnabled(state),
  isCustomDomainEnabled: state.customDomainEnabled,
  isSchedulesPageHidden: isSelfServiceSchedulingEnabledForAllContentTypes(),
  isGroupSetsEnabled: SessionSiteSelectors.isGroupSetsEnabledForSite(state),
  isCloudAdmin: SessionUserSelectors.isCloudAdmin(state)
});

export const ConnectedNavPanel: React.ComponentClass<NavPanelOwnProps> =
  connect(mapStateToProps)(NavPanel);
